import { DestroyRef, Directive, ElementRef, inject, Input, OnInit, Renderer2 } from '@angular/core';
import { AuthService } from '../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[auditorSimulationMode]',
})
export class AuditorSimulationModeDirective implements OnInit {
  private readonly element = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);

  @Input()
  auditorSimulationMode: string[] = [];

  ngOnInit(): void {
    this.authService
      .isAuditorSimulationMode()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isAuditorSimulation) => {
        this.updateClasses(isAuditorSimulation);
      });
  }

  private updateClasses(condition: boolean): void {
    this.auditorSimulationMode.forEach((className) => {
      if (condition && this.element.nativeElement) {
        this.renderer.addClass(this.element.nativeElement, className);
      } else {
        this.renderer.removeClass(this.element.nativeElement, className);
      }
    });
  }
}
